import { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';

const ListImages = ({ index, allFiles, setValue, getValues }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const { newImages } = allFiles(index);
    setImages(newImages || []);
  }, [allFiles, index]);

  const removeImage = (ind) => {
    const currentFiles = getValues(`cars.${index}.filesUrl`) || [];
    const imageToRemove = images[ind];

    const updatedImages = images.filter((_, index) => index !== ind);
    const updatedFiles = currentFiles.filter((file) => file !== imageToRemove);

    setImages(updatedImages);
    setValue(`cars.${index}.filesUrl`, updatedFiles, { shouldValidate: true });
  };

  return (
    <div className="grid md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-4 xl:grid-cols-4 sm:grid-cols-2 gap-x-4 mt-3">
      {images?.map((image, i) => (
        <div
          key={i}
          className="border border-[#999999] rounded-[5px] flex items-center justify-center relative"
        >
          <img
            src={image}
            className="w-[100%] h-[150px]"
            alt={`Upload ${i + 1}`}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'fallback-image-url';
            }}
          />
          <div
            className="bg-[#ffffff] flex items-center justify-center cursor-pointer rounded-full w-[15px] h-[15px] absolute top-[-10px] right-[-10px]"
            onClick={() => removeImage(i)}
          >
            <FaTimes className="text-[#ff0000] text-[12px]" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListImages;
